interface Action {
    payload: any,
    type: string,
    field: string,
    value?: any,
    apiError?: string | boolean,
    validate: boolean
}

const errors: {
    [key: string]: string
} = {
    fullName: "Please add a full name.",
    lastName: "Please add a last name.",
    firstName: "Please add a first name.",
    email: "Please add an email.",
    validEmail: "Please add a valid email address.",
    validPhone: "Please add a valid phone number.",
    password: "Please add a strong password.",
    emptyPass: "Please add a password.",
    phone: "Please add a phone number.",
    userExist: 'This email is already registered.'
};

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,50}$/;

const passwordPattern: {
    [key: string]: any
} = {
    n: /[0-9]/,
    u: /[A-Z]/,
    l: /[a-z]/
};
const passwordLength = 8;


export default (data: any, action: Action) => {
    const newForm = data;
    const prop = newForm[action.field];
    const customFields = ['fullName','email','password','phone'];

    if (prop) {
        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true
        }

        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }

        if (action.field === 'fullName') {
            if (action.value) {
                // newForm.fullName.error = null;
                const name = action.value.split(' ').filter((el: any) => el !== '');
                newForm.firstName.value = name[0];
                newForm.firstName.error = !name[0] ? errors.fullName : '';
                name.shift();
                newForm.lastName.value = name.join(' ');
                const l = newForm.lastName.value && newForm.lastName.value.length > 1 ? newForm.lastName.value?.trim() : false;
                newForm.lastName.error = !newForm.lastName.value || !l ? errors.lastName : '';
                newForm.fullName.error = newForm.firstName.error || newForm.lastName.error ? errors['fullName'] : null;
            } else if (prop.added && !action.value){
                newForm.fullName.error = errors['fullName'];
            }
        }
        if (action.field === 'email') {
            prop.error = !emailPattern.test(action.value) ? errors['validEmail'] : null;
            prop.error = action.apiError ? (typeof action.apiError === 'string' ? action.apiError : errors['userExist']) : prop.error;
        }
        if (action.field === 'password') {
           if (action.value)  {
               for (const p in passwordPattern) {
                   prop.errTypes[p] = !passwordPattern[p].test(action.value);
               }
               prop.errTypes.min = (action.value || '').length < passwordLength;
           }

           prop.error = Object.values(prop.errTypes).includes(true) || (prop.added && !action.value) ? errors['password'] : null;
        }
        if (action.field === 'phone') {
            prop.error = action.value && `${action.value}`.length < 10 || (prop.added && !action.value) ? errors['validPhone'] : null
            //return (!phone || phone && phone.trim('').length < 14) ? this.FormErrors.phoneNumber : false;
        }

        if (!customFields.includes(action.field)) {
            prop.error = (prop.added && !action.value && prop.required) ? errors[action.field] : null;
        }
        prop.value = action.value;
    }
    const vals = Object.values(newForm).filter((f: any) => f.required);
    const valid = vals.filter((f: any) => f.added && f.value && !f.error);
    return {
        changed: true,
        valid: valid.length === vals.length,
        data: newForm,
    };
};
